module.exports = __webpack_public_path__ + "img/avatar.f6eb833e.png";